<template>
    <f7-page
        :hide-bars-on-scroll="isPgap ? true : false"
        :class="`unit-page font-${fontSize}`"
        name="Unit"
        no-swipeback
    >
        <f7-navbar
            no-hairline
            no-shadow
            inner-class="unitNavbar"
        >
            <f7-nav-left>
                <f7-link
                    v-if="onboardingCompleted > 1 && localUnit.id !== BEGIN_THE_REVOLUTION && localUnit.id !== YOUR_WEEKLY_PULSE && localUnit.id !== 0"
                    aria-label="FontSize"
                    href="#"
                    style="padding: 6px 0 0 16px;"
                    @click="setFontSize"
                >
                    <span style="font-family: Editor; font-weight: bold; vertical-align: bottom">A<span style="font-size: 28px">A</span></span>
                </f7-link>
                <f7-link
                    v-if="onboardingCompleted > 1 && localUnit.id !== BEGIN_THE_REVOLUTION && localUnit.id !== YOUR_WEEKLY_PULSE && localUnit.id !== 0"
                    aria-label="Bookmark"
                    icon-only
                    href="#"
                    style="padding: 0 6px 0 0; margin: 0 6px 0"
                    @click="bookmark"
                >
                    <!-- <i :class="`icon ${unit.bookmarked ? 'ion-android-star' : 'ion-android-star-outline'}`" /> -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 17 18"
                    >
                        <polygon
                            :fill="localUnit.bookmarked ? (darkTheme ? '#fff' : '#000') : 'none'"
                            :stroke="darkTheme ? 'white' : 'black'"
                            stroke-width="1"
                            points="18 29 18 13 33.048 13 33.048 29 25.524 23.245"
                            transform="translate(-17 -12)"
                        />
                    </svg>
                </f7-link>
            </f7-nav-left>
            <f7-nav-title />
            <f7-nav-right>
                <f7-link
                    v-if="localUnit.id !== BEGIN_THE_REVOLUTION && localUnit.id !== 0 && user.unitsCompleted > 1"
                    aria-label="Close"
                    href="#"
                    style="padding: 0 10px 0;"
                    @click="closePopup();"
                >
                    <i
                        class="icon ion-close-round"
                        style="font-size: 20px"
                    />
                </f7-link>
            </f7-nav-right>
        </f7-navbar>

        <slide
            v-if="localUnit.slides[slideIndex]"
            :key="`units-${localUnit.id}-${slideIndex}`"
            :slide="localUnit.slides[slideIndex]"
            :index="slideIndex"
            :total="localUnit.slides.length"
            :unit="localUnit"
            :redo="redo"
        />

        <f7-toolbar
            v-if="localUnit.id !== YOUR_WEEKLY_PULSE"
            bottom
            class="unitToolbar"
        >
            <f7-link
                v-if="localUnit.slides && localUnit.slides.length > 1 && slideIndex > 0"
                aria-label="Back"
                @click="prevSlide();"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="16"
                    viewBox="0 0 10 16"
                >
                    <path
                        fill="none"
                        stroke="#F07969"
                        stroke-width="1"
                        d="M25,14 L32.8623073,21.8623073 C33.0466102,22.0466102 33.0466102,22.3453719 32.8623073,22.5296748 L25.3919822,30"
                        transform="rotate(-180 17 15)"
                    />
                </svg>

            </f7-link>
            <f7-link
                aria-label="Share"
                @click="share"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="#F07969"
                        stroke-width="1"
                        transform="translate(1 1)"
                    >
                        <polyline points="0 9.49 0 15.169 13.65 15.169 13.65 9.49" />
                        <path
                            stroke-linecap="square"
                            d="M6.95454545,10.2626904 L6.95454545,0.989963089"
                        />
                        <path
                            d="M5.0225982,-1.71445329 L8.81973527,2.08268378 C8.90874519,2.1716937 8.90874519,2.31598202 8.81973527,2.40499194 L5.21190777,6.01281944"
                            transform="rotate(-90 6.955 2.15)"
                        />
                    </g>
                </svg>
            </f7-link>
            <f7-link
                :href="localUnit.id ? `/units/${localUnit.id}/comments` : '/start'"
                aria-label="Comment"
            >
                {{ localUnit.comments }}&nbsp;<svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                >
                    <path
                        fill="none"
                        stroke="#F07969"
                        stroke-width="1"
                        d="M237.625,31.181497 L237.625,27.4588526 L237.719027,27.3524755 C238.950824,25.9588903 239.625,24.2718429 239.625,22.5 C239.625,18.0274249 235.32803,14.375 230,14.375 C224.67197,14.375 220.375,18.0274249 220.375,22.5 C220.375,26.9725751 224.67197,30.625 230,30.625 C231.850346,30.625 233.622044,30.1833196 235.149635,29.3644915 L235.37663,29.2428164 L237.625,31.181497 Z"
                        transform="translate(-220 -14)"
                    />
                </svg>
            </f7-link>
            <f7-link
                aria-label="Like"
                @click="likeUnit(localUnit)"
            >
                {{ localUnit.likes }}&nbsp;<svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="17"
                    viewBox="0 0 20 17"
                >
                    <path
                        :fill="localUnit.liked ? '#F07969' : 'none'"
                        stroke="#F07969"
                        d="M339.986462,16.0993285 C338.133838,15.7208355 336.480421,16.5176628 334.906687,18.5495726 C334.906687,18.5694933 334.866846,18.5694933 334.866846,18.5495726 C333.293112,16.4977421 331.619775,15.7009148 329.787072,16.0993285 C327.635638,16.5375835 326.062103,18.3902071 326.002142,20.5217203 C325.982221,21.1791028 326.101745,21.796644 326.340793,22.3942646 C326.759327,23.4301401 329.050206,25.7010981 331.998268,28.5895973 C332.795095,29.3665039 333.552081,30.1035692 334.089939,30.6613484 C334.309067,30.8804759 334.587956,31 334.886767,31 C335.185577,31 335.464666,30.8804759 335.683594,30.6613484 C336.221652,30.1035692 336.978438,29.3665039 337.775266,28.5895973 C340.723527,25.7210188 343.014406,23.4301401 343.432939,22.3942646 C343.671788,21.796644 343.791512,21.1591822 343.771392,20.5217203 C343.71163,18.3902071 342.138095,16.5375835 339.986462,16.0993285"
                        transform="translate(-325 -15)"
                    />
                </svg>

            </f7-link>

            <f7-link
                v-if="localUnit.slides[slideIndex] && localUnit.slides[slideIndex].data && localUnit.slides[slideIndex].data.references && localUnit.slides[slideIndex].data.references.length > 22"
                :href="`/references/${localUnit.id}?page=${slideIndex}`"
                aria-label="References"
            >
                <i
                    class="ion-university"
                    style="font-size: 20px"
                /> ref
            </f7-link>
        </f7-toolbar>

    </f7-page>
</template>

<script>
import Slide from '../../components/slide.vue';
import utils from '../../js/utils';
import {
    BEGIN_THE_REVOLUTION,
    YOUR_WEEKLY_PULSE
} from '../../js/constants';

export default {
    store: [
        'api',
        'user',
        'coursesIndex',
        'unitsIndex',
        'currentCourse',
        'myTraits',
        'onboardingCompleted',
        'trackerData',
        'fontSize',
        'fullDataIndex',
        'darkTheme',
        'unit',
        'unit2',
        'unit3'
    ],
    components: {
        slide: Slide
    },
    data () {
        return {
            showRef: false,
            fromHome: false,
            currentId: 0,
            slideIndex: 0,
            redo: false,
            localUnit: {
                id: 0,
                title: '',
                data: {},
                slides: [],
                bookmarked: false,
                description: false,
                hasAudio: false
            },
            BEGIN_THE_REVOLUTION,
            YOUR_WEEKLY_PULSE,
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    created: function () {
        if (this.$f7route.params.id) {
            this.currentId = this.$f7route.params.id;
        }
        if (this.$f7route.query.page) {
            this.slideIndex = parseFloat(this.$f7route.query.page);
        }
        if (this.$f7route.query.redo) {
            this.redo = true;
        }
        if (this.$f7route.query.home) {
            this.fromHome = true;
        }

        this.getUnit();

        if (parseFloat(this.currentId) === 285) {
            this.$events.fire('pulse-get');
        }
    },
    mounted: function () {
        if (pgap && window.plugins.insomnia) window.plugins.insomnia.keepAwake();
        this.$events.off(`unit-next-${this.currentId}`);
        this.$events.on(`unit-next-${this.currentId}`, complete => {
            this.nextSlide(complete);
        });
    },
    beforeDestroy () {},
    methods: {
        renderText: function (text) {
            // remove already set targets
            text = text.replace(/(<a [^>]*)(target="[^"]*")([^>]*>)/gi, '$1$3');
            // remove already set classes
            text = text.replace(/(<a [^>]*)(class="[^"]*")([^>]*>)/gi, '$1$3');
            // add new target="_blank"
            let destination = pgap ? '_system' : '_blank';
            return text.replace(/(<a [^>]*)(>)/gi, '$1 target="' + destination + '" class="external" $2');
        },
        share: function () {
            this.$events.fire('trackEvent', 'share', 'share', this.localUnit.id, this.localUnit.name);
            // f7.dialog.alert('Sharing is disabled during the private BETA.');
            utils.shareModule(
                `"${this.localUnit.name}" on Coral: Horizontal happiness`,
                this.localUnit.description,
                `/units/${this.localUnit.id}`,
                'unit',
                this.user.id
            );
        },
        likeUnit: function (unit) {
            if (!this.user.id) {
                return f7.views['main'].router.navigate({
                    url: `/start`
                });
            }
            this.$http[unit.liked ? 'delete' : 'post'](`${this.api}/units/${unit.id}/like`).then(
                () => {
                    if (unit.liked) {
                        unit.likes--;
                    } else {
                        unit.likes++;
                    }
                    unit.liked = !unit.liked;
                },
                response => {
                    utils.failedRequest('popup', response);
                }
            );
        },
        showNextButton: function () {
            // Show button on last slide
            if (this.slideIndex >= this.localUnit.slides.length - 1) return true;
            // Show button on first slide
            if (this.slideIndex === 0) return true;
            // Else do not show button
            return false;
        },
        closePopup: function () {
            if (pgap) window.Vibrate.vibrate('light');
            if (pgap && window.plugins.insomnia) window.plugins.insomnia.allowSleepAgain();
            if (!this.user.id) {
                f7.popup.get(`#popup`).open();
                f7.popup.get(`#popup`).close();
                if (!pgap && location.hostname !== 'localhost') {
                    window.location.href = `https://getcoralapp.co/login/?isFromUnitPass=true&unitId=${this.localUnit.id}`;
                    window.history.pushState(null, null, window.location.href);
                    window.onpopstate = function () {
                        window.history.go(1);
                    };
                }

                return;
            }

            if (this.localUnit.id === YOUR_WEEKLY_PULSE && !localStore.getItem('trackerTakenOnce')) {
                localStore.setItem('trackerTakenOnce', 1)
                f7.views['main'].router.navigate('/home', { reload: false, animatePages: false });
            }

            if (this.$f7router.view.main) {
                if (f7.views['main'].router.history.length === 1) {
                    f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
                }
            }

            if (!pgap) {
                window.history.pushState(null, "", '/web' + f7.views['main'].router.currentRoute.path);
            }

            return setTimeout(() => {
                if (f7.popup.get(`#${this.$f7router.view.name}`)) {
                    f7.popup.get(`#${this.$f7router.view.name}`).open();
                    f7.popup.get(`#${this.$f7router.view.name}`).close();
                }
            }, 300);
        },
        setFontSize: function () {
            f7.dialog
                .create({
                    title: 'Coral',
                    text: 'Choose a font size',
                    buttons: [
                        {
                            text: '<span style="font-size: 24px">Large</span>',
                            onClick: () => {
                                this.fontSize = 'large';
                                localStore.setItem('fontSize', this.fontSize);
                            }
                        },
                        {
                            text: 'Normal',
                            onClick: () => {
                                this.fontSize = 'normal';
                                localStore.setItem('fontSize', this.fontSize);
                            }
                        },
                        {
                            text: '<span style="font-size: 14px">Small</span>',
                            onClick: () => {
                                this.fontSize = 'small';
                                localStore.setItem('fontSize', this.fontSize);
                            }
                        }
                    ],
                    verticalButtons: true
                })
                .open();
        },
        bookmark: function () {
            if (!this.user.id) {
                this.closePopup();
            }
            if (!window.localStore.getItem('coachmarkBookmark')) {
                f7.dialog.alert('You can find bookmarked units in your profile.', 'Done and done!', () => {
                    window.localStore.setItem('coachmarkBookmark', true);
                });
            }
            let send = {
                unitId: this.localUnit.isVersionOf || this.localUnit.id,
                slideId: 0 // this.unit.slides[slideIndex].id
            };
            if (this.localUnit.bookmarked) {
                send = {
                    body: send
                };
            }
            if (pgap) window.Vibrate.vibrate('light');
            this.$http[this.localUnit.bookmarked ? 'delete' : 'post'](`${this.api}/bookmarks`, send)
                .then(() => {
                    if (!this.localUnit.bookmarked) {
                        this.$events.fire('trackEvent', 'bookmark', 'behaviour', this.localUnit.id, this.localUnit.name, {});
                    }
                }, () => { });
            this.localUnit.bookmarked = !this.localUnit.bookmarked;
        },
        completeUnit: function () {
            if (!this.user.id) {
                this.closePopup();

                return true;
            }
            let unitId = this.localUnit.isVersionOf || this.localUnit.id;
            if (!this.localUnit.isVersionOf) {
                this.localUnit.completed = true;
                Vue.set(this.unit, 'completed', true);
            }
            Vue.set(this.unitsIndex[unitId], 'completed', true);
            Vue.set(this.unitsIndex, unitId, this.unitsIndex[unitId]);
            this.$events.fire('user-progress', {
                itemId: unitId,
                courseId: this.localUnit.courseId,
                topicId: this.coursesIndex[this.localUnit.courseId] ? this.coursesIndex[this.localUnit.courseId].topicId : 0,
                type: 'unit',
                progress: 100,
                completed: true,
                item: this.localUnit
            });
            this.$events.fire(`unit-completed-${unitId}`);
            let eligible = 0;
            let completed = 0;
            if (this.coursesIndex[this.localUnit.courseId]) {
                for (let i = 0; i < this.coursesIndex[this.localUnit.courseId].units.length; i++) {
                    const unit = this.coursesIndex[this.localUnit.courseId].units[i];
                    if (utils.checkTraits(this.myTraits, unit)) {
                        eligible++;
                        if (this.unitsIndex[unit.id].completed) completed++;
                    }
                }
            }
            // lastEligibleUnitInCourse
            // console.log(this.unit.courseId, this.coursesIndex[this.unit.courseId]);
            //  console.log('LastEligibleUnitInCourse', this.coursesIndex[this.unit.courseId].units.length, eligible, completed);
            if (eligible && eligible === completed) {
                this.$f7router.view.router.navigate({
                    url: `/courses/${this.localUnit.courseId}/complete`,
                    reloadCurrent: true
                });
                return true;
            }
            return false;
        },
        nextSlide: function (isLast) {
            console.log('[navigation] next slide, isLast:', isLast);
            // if last slide
            if (isLast || this.slideIndex === this.localUnit.slides.length - 1) {
                // complete unit
                if (
                    this.unitsIndex[this.localUnit.isVersionOf || this.localUnit.id] &&
                    !this.unitsIndex[this.localUnit.isVersionOf || this.localUnit.id].completed
                ) {
                    let redirect = this.completeUnit();
                    console.log('Completing... redirect', redirect);
                    if (redirect) {
                        return;
                    }
                } else {
                    // unpublished unit support
                    this.$events.fire('user-progress', {
                        itemId: this.localUnit.isVersionOf || this.localUnit.id,
                        courseId: this.localUnit.courseId,
                        topicId: this.coursesIndex[this.localUnit.courseId] ? this.coursesIndex[this.localUnit.courseId].topicId : 0,
                        type: 'unit',
                        progress: 100,
                        completed: true,
                        item: this.localUnit
                    });
                }
                // tracker support
                if (this.localUnit.type === 'tracker') {
                    return this.closePopup(false);
                }

                return this.closePopup(false);
            } else {
                this.$events.fire('user-progress', {
                    itemId: this.localUnit.isVersionOf || this.localUnit.id,
                    courseId: this.localUnit.courseId,
                    topicId: this.coursesIndex[this.localUnit.courseId].topicId,
                    type: 'unit',
                    progress: parseFloat((this.slideIndex + (2 / this.localUnit.slides.length) * 100).toFixed(0)),
                    item: this.localUnit,
                    complete: false
                });
                this.$f7router.view.router.navigate(`/units/${this.localUnit.id}?page=${this.slideIndex + 1}`);
            }
        },
        prevSlide: function () {
            this.$f7router.view.router.back();
            //this.$f7router.view.router.navigate(`/units/${this.localUnit.id}?page=${this.slideIndex - 1}`);
        },
        goTo: function (url) {
            this.$f7router.view.router.navigate(url);
        },
        getUnit: function () {
            console.log(`[Get unit] [${this.$f7router.view.name}]`, this.currentId);
            if (this.$f7router.view.name === 'popup') {
                this.localUnit = this.unit;
            } else if (this.$f7router.view.name === 'popup2') {
                this.localUnit = this.unit2;
            } else if (this.$f7router.view.name === 'popup3') {
                this.localUnit = this.unit3;
            }
            if (this.localUnit.id === parseFloat(this.currentId)) {
                this.localUnit.courseId = this.currentCourse ? this.currentCourse.id : 0;
                console.log('[Get unit] ', 'from cache');
                return;
            }

            Vue.set(this, 'localUnit', {
                id: 0,
                title: '',
                data: {},
                slides: [],
                bookmarked: false,
                liked: false,
                courseId: this.currentCourse ? this.currentCourse.id : 0,
            });
            f7.preloader.show();
            this.$http.get(`${this.api}/units/${this.currentId}`).then(
                response => {
                    const responseUnit = response.body;

                    if (responseUnit.slides.length === 0) {
                        responseUnit.slides.push({
                            id: 1,
                            // must be 20 chars
                            text: '<p><h3>No slides here yet!</h3></p>',
                            data: {
                                references: ''
                            },
                            type: '',
                            attachments: []
                        });
                    }
                    responseUnit.fromServer = true;
                    if (!responseUnit.courseId && this.currentCourse && this.currentCourse.id) {
                        responseUnit.courseId = this.currentCourse.id;
                    }
                    if (this.$f7router.view.name === 'popup') {
                        Vue.set(this, 'unit', responseUnit)
                    } else if (this.$f7router.view.name === 'popup2') {
                        Vue.set(this, 'unit2', responseUnit)
                    } else if (this.$f7router.view.name === 'popup3') {
                        Vue.set(this, 'unit3', responseUnit)
                    }

                    document.title = responseUnit ? responseUnit.name : document.title;

                    Vue.set(this, 'localUnit', responseUnit)
                    this.getCourse();
                    f7.preloader.hide();
                },
                response => {
                    utils.failedRequest('popup', response);
                    f7.preloader.hide();
                }
            );
        },
        getCourse: function () {
            this.course = this.coursesIndex[this.localUnit.courseId];
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}
.bottom {
    position: absolute;
    bottom: 40px;
}
.coralButton {
    font-size: 18px;
    color: white;
    background: #a5acc4;
    border-radius: 22px;
    padding: 15px 30px;
}
#slides {
    padding-top: 0px;
    margin-top: calc(0 - var(--f7-navbar-height) - var(--f7-navbar-large-title-height));
    height: 100%;
}
@media (min-height: 630px) and (min-width: 630px) {
    #slides {
        height: var(--f7-popup-tablet-height);
    }
}

.progressBar {
    display: none;
    position: fixed;
    bottom: 0px;
    background: #e0e0e0;
    width: 100%;
    height: 10px;
    z-index: 9;
    .progress {
        background: @green;
        height: 10px;
        -webkit-transition: width 2s;
        transition: width 2s;
    }
}

.nextButton {
    z-index: 9999;
    margin-left: -35px;
    left: 50%;
    position: fixed;
    bottom: 60px;
    background: @green;
    color: white;
    height: 70px;
    width: 70px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    i {
        color: white;
        font-size: 40px;
        line-height: 78px;
    }
    &.hasChat {
        margin-left: 35px;
    }
    &.chat {
        margin-left: -105px;
    }
}
.dark .nextButton {
    z-index: 9999;
    margin-left: -35px;
    left: 50%;
    position: fixed;
    bottom: 60px;
    background: white;
    color: @green;
    height: 70px;
    width: 70px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    i {
        color: @green;
        font-size: 40px;
        line-height: 78px;
    }
}
.unitToolbar {
    padding: 0 20px;
    background: @background;
    text-transform: uppercase;
    font-family: AndesMedium;
    letter-spacing: 1px;
    // font-size: 12px;
    a {
        padding: 16px;
        color: @coral;
        font-size: 12px;
    }
    // letter-spacing: 1px;
    // text-align: center;
    // line-height: 10px;
}
.theme-dark {
    .unitToolbar {
        background: #1c1c1d;
    }
}
</style>
